import React, { useState, useEffect } from "react";
// Styles
import "./rwd.style.css";
// Images
import ArrowBottomIcon from "../../assets/images/icons/arrow-b.png";
import RewardDetailImg from "../../assets/images/rewards/reward-detail.png";
// Card (Platinum)
import PlatNhCard from "../../assets/images/cards/card NH (platinum).png";
import PlatNhBadge_Active from "../../assets/images/cards/platinum(active).png";
import PlatNhBadge_Inactive from "../../assets/images/cards/platinum(inactive).png";
// Components
import { Base_API } from '../../_actions/matcher'
import { NhealthAction } from '../../_actions/action.api'
// Sweet Alert 2
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

function RewardDetails({ openDetail, setOpenDetail, data, handleRedeem }) {
    const [alertStatus, setAlertStatus] = useState(false);
    const [alertNormalStatus, setAlertNormalStatus] = useState(false);
    const [title, setTitle] = useState('ยืนยันการแลกคะแนน');
    const [pdName, setPdName] = useState('เครื่องจ่ายแอลกอฮอล์อัตโนมัติ พร้อมน้ำยา');
    const [pointRedeem, setPointRedeem] = useState(400);
    const [expDate, setExpDate] = useState('15 พ.ย. 2565');
    const [btnText, setBtnText] = useState('ยืนยัน');
    const [typeRedeem, setTypeRedeem] = useState('');
    const [pageDetail, setPageDetail] = useState({
        serviceLocationText: ''
    });
    const [banner, setBanner] = useState('');

    useEffect(() => {
        dataInit();
    }, [openDetail])

    const dataInit = async() => {
        await serviceLocationInit();
    }

    const serviceLocationInit =() => {
        return new Promise(async resolve => {
            if(!!data)
            {
                if(data.hospital.length > 0)
                {
                    setTypeRedeem('reward');

                    let hospitalListText = String(data.hospital.map(item => item.hospital));
                    let servicesText = `สามารถรับบริการได้ที่สาขา ${hospitalListText}`;
                    // console.log(servicesText);
                    setPageDetail({
                        ...pageDetail,
                        serviceLocationText: servicesText
                    })
                }else
                {
                    setTypeRedeem('coupon');
                }
                let urlBanner = data.Cover;
                setBanner(urlBanner);
                resolve();
            }
        })
    }

    // Handle Close Details
    const handleCloseDetails = () => {
        setOpenDetail(false);
        document.body.style.overflow = "scroll";
    };

    // Handle Alert Confirm Redeem
    const alertConfirmRedeem = () => {
        MySwal.fire({
            html: alertElem,
            showCancelButton: false,
            showConfirmButton: false
        });
    };

    // Handle Close Alert
    const handleCloseAlert = () => {
        MySwal.close();
    }

    const renderDetail = (
        <div dangerouslySetInnerHTML={{__html: !!data && data.description}}></div>
    )

    // Alert (Element)
    let alertElem = 
        <div className="swal2-rwds-con">
            <h1 className="title">{title}</h1>
            <p className="desc">{!!data && data.Title}</p>
            <p className="prd-text t-normal">คะแนนใช้แลก</p>
            <h3 className="prd-value t-blue">{!!data && Number(data.redeemPoint).toLocaleString('th')} <span>คะแนน</span></h3>
            {/* <p className="rw-expi t-normal">หมดเขต <span className="t-bold">{expDate}</span></p> */}
            <div className="btn-wrapper">
                <button 
                    className="cancel"
                    onClick={handleCloseAlert}
                >
                    ยกเลิก
                </button>
                <button 
                    className="endpoint"
                    onClick={() => handleRedeem(!!data && data)}
                >
                    {btnText}
                </button>
            </div>
        </div>
    ;

    return (
        <div className={`rwd-container ${openDetail ? "active" : ""}`}>
        {/* arrow */}
        <span className="rwd-switch" onClick={handleCloseDetails}>
            <img src={ArrowBottomIcon} />
        </span>

        {/* header text (rw name) */}
        <h1 className="header-text">{!!data && data.Title}</h1>
        {/* Point redeem text */}
        <p className="prd-text t-normal">คะแนนใช้แลก</p>
        {/* Point Redeem */}
        <h3 className="prd-value">
            {!!data && Number(data.redeemPoint).toLocaleString('th')} <span>คะแนน</span>
        </h3>
        {/* Reward Expiresin */}
        {/* <p className="rw-expi t-normal">
            หมดเขต <span className="t-bold">15 พ.ย. 2565</span>
        </p> */}

        {/* Reward Img */}
        <img
            className="rwdt-img"
            src={banner}
            // style={{ backgroundImage: `url("${banner}")` }}
        />
        {/* <img 
            src={pageDetail.banner} 
            className="rwdt-banner"
        /> */}

        {/* Reward Details */}
        <div className="details-wrap">
            <p className="rwdt-title t-bold">รายละเอียดของรางวัล</p>
            {renderDetail}

            {/* Copy Reward Code */}
            {typeRedeem === "reward" && null
                // <p className="svcs-lcts-wrap">
                //     {/* <img src={Pin} /> */}
                //     {pageDetail.serviceLocationText}
                // </p>
            }

            {/* <ul className="list">
                <li className="t-lowblue t-normal">
                    <span>•</span> สามารถซื้อแพ็กเกจและชำระเงินได้ภายในวันที่ 1-12 ก.ค.
                    65 เท่านั้น
                </li>
                <li className="t-lowblue t-normal">
                    <span>•</span> สามารถรับบริการได้ตั้งแต่วันที่ 1 ก.ค.- 30 ก.ย.65
                </li>
                <li className="t-lowblue t-normal">
                    <span>•</span> สามารถรับบริการได้ที่ Lab Center N Health ทุกสาขา
                </li>
            </ul> */}

            {/* rw policy */}
            {/* <p className="plc-title t-lowblue t-normal">ข้อกำหนดและเงื่อนไข</p>
            <ul className="plc-list">
            <li className="t-lowblue t-normal">
                <span>1.</span> เพื่อให้ท่านได้รับบริการที่สะดวกรวดเร็ว
                กรุณานัดหมายล่วงหน้า 1 วัน
            </li>
            <li className="t-lowblue t-normal">
                <span>2.</span>{" "}
                กรณีที่ท่านไม่ได้ทำการนัดหมายล่วงหน้าเจ้าหน้าที่ขอตรวจสอบข้อมูล
                การชำระเงินโดยท่านต้องแสดงหลักฐานใบเสร็จรับเงินกับเจ้าหน้าที่
            </li>
            <li className="t-lowblue t-normal">
                <span>3.</span>{" "}
                หากท่านไม่ได้เป็นผู้เข้ารับการตรวจสุขภาพเองขอให้ผู้ที่เข้ารับบริการแทนแสดง
                หลักฐานใบเสร็จของท่านเพื่อรับบริการ
            </li>
            <li className="t-lowblue t-normal">
                <span>4.</span> แพ็กเกจที่ท่านได้สั่งซื้อและชำระเงินแล้ว
                ไม่สามารถแลก เปลี่ยน หรือคืนเป็นเงินสดได้
            </li>
            </ul> */}
        </div>
        {/* Button Redeem */}
        <div className="btn-rd-wrap">
            <button 
                className={!!data && data.isRedeem === true ? "btn-redeem" : "btn-redeem disabled"} 
                onClick={!!data && data.isRedeem === true ? alertConfirmRedeem : null}
            >
                แลกคะแนน
            </button>
        </div>
        </div>
    );
}

export default RewardDetails;
